const messagesMultiSelect = (loading = false) => {
  const messages = {
    searchPlaceholder: 'Buscar',
    noItemsMessage: loading ? 'Carregando...' : 'Nada selecionado',
    noneSelectedMessage: loading ? 'Carregando...' : 'Nenhum item selecionado',
    selectedMessage: 'selecionado(s)',
    selectAllMessage: 'Selecionar Todos',
    clearAllMessage: 'Limpar Todos',
    disabledItemsTooltip: 'You can only select 1 file',
  }
  return messages
}

export default messagesMultiSelect
